import * as React from "react"
import {useCallback} from "react"
import {Box, Tabs, Tab} from "@mui/material"

import {BATCH_ADMIN_ROUTES} from "@constants"
import PageWrapper from "../../@PageWrapper"
import BatchesTable from "./Table"
import BatchDetailsDrawer from "./DetailsDrawer"
import CreateBatchDrawer from "./CreateBatchDrawer"
import CreatingBatchModal from "./CreatingBatchModal"
import BatchItemsTable from "./BatchItemsTable"
import AutovalidateDrawer from "./AutovalidateDrawer"
import SchedulesPage from "../Schedules"
import {activeBatchTab, selectedBatchIds} from "./@signals"


export default function BatchesPage() {

    const handleTabChange = useCallback((event, newValue) => {
        activeBatchTab.value = newValue
        selectedBatchIds.value = [] // Clear selection when tab changes
    }, [])

    const showSchedulesTab = activeBatchTab.value === 'schedules'

    return <PageWrapper
        head={`SKU Mapper | ${BATCH_ADMIN_ROUTES.LIST_SUBTITLE}`}
        title={BATCH_ADMIN_ROUTES.TITLE}
        subtitle={BATCH_ADMIN_ROUTES.LIST_SUBTITLE}
    >
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tabs value={activeBatchTab.value} onChange={handleTabChange}>
                <Tab label="SKU to Product" value="sku2raw" />
                <Tab label="Product to SKU" value="raw2sku" />
                <Tab label="Product to Product" value="raw2raw" />
                <Tab label="Competitor to Own" value="war2war" />
                <Tab label="Schedules" value="schedules" />
            </Tabs>
        </Box>

        {showSchedulesTab ? (
            <SchedulesPage />
        ) : (
            <>
                <BatchesTable />
                <BatchItemsTable />
                <BatchDetailsDrawer />
                <CreateBatchDrawer />
                <CreatingBatchModal />
                <AutovalidateDrawer />
            </>
        )}
    </PageWrapper>
}
